<template>
  <div>
    <div class="banner">
      <div class="userCon">
        <h1>您可能还存在这些疑惑</h1>
        <p>心理亦笙为您解答</p>
      </div>
    </div>
    <div class="doubt">
      <div class="userCon">
        <div v-for="(item,index) in problemOptions" class="problemOptions" :key="index">
          <h3 class="flex"><i class="el-icon-search icon"></i>{{ item.itemName }}</h3>
          <p class="answer">
            <span class=" icon">A</span>
            <span class="itemDesc">{{ item.itemDesc }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import base from "@/api/common";

export default {
  name: "doubt",
  data() {
    return {
      problemOptions: [],
    }
  },
  mounted() {
    //获取用户疑惑
    this.$ajax.get(base.api.dict.userQA).then((res) => {
      if (res.data.status === 'success') {
        this.problemOptions = res.data.list;
      }
    })
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/index_b';
</style>
